<template>
    <div class="auth-wrap">
        <div class="logo-wrap">
            <img class="logo-image" src="https://yequ-admin-1331262631.cos.ap-nanjing.myqcloud.com/general/logo/logo.png" />
            <div class="system-name">心野管理后台</div>
        </div>

        <div class="login-wrap">
            <div class="form-title">账号登录</div>
            <div class="form-wrap">
                <t-input 
                    v-model="username"
                    class="account-input"              
                    placeholder="请输入账户名"
                    size="large"
                    clearable
                >
                    <template #prefix-icon>
                        <user-icon />
                    </template>
                </t-input>

                <t-input
                    v-model="password"
                    class="password-input"
                    type="password"
                    placeholder="请输入密码"
                    size="large"
                    clearable 
                >
                    <template #prefix-icon>
                        <lock-on-icon />
                    </template>
                </t-input>

                <t-button
                    @click="LoginClick"
                    :loading="loading"
                    theme="primary"
                    size="large"
                >
                    登录
                </t-button>

            </div>
        </div>
        
        <div class="footer">
                <a href="https://beian.miit.gov.cn/" target="_blank"  class="icp-info">
                    冀ICP备2024092063号-1
                </a>
        </div>
       
    </div>
</template>


<script setup>
    import { ref } from 'vue';
    import { useRouter } from 'vue-router';
    import { LockOnIcon, UserIcon } from 'tdesign-icons-vue-next';
    import { MessagePlugin } from 'tdesign-vue-next';
    import adminUserAPI from '../../api/admin-user-api'

    const router = useRouter();
    const username = ref('');
    const password = ref('');
    const loading = ref(false);

    const validate = () => {
        if (!username.value && !password.value) {
            MessagePlugin.error('请输入用户名和密码');
            return false;
        }
        if (!username.value) {
            MessagePlugin.error('请输入用户名');
            return false;
        }
        if (!password.value) {
            MessagePlugin.error('请输入密码');
            return false;
        }
        return true;
    };

    const LoginClick = async () => {
  if (!validate()) {
    return;
  }

  loading.value = true;
  try {
    const res = await adminUserAPI.login(username.value, password.value);
    if (res.token) {
      MessagePlugin.success('登录成功');
      localStorage.setItem('token', res.token);
      localStorage.setItem('username', res.username);
      //console.log('存储的 token:', localStorage.getItem('token'));
      router.push('/').then(() => {
        console.log('跳转成功');
      }).catch(err => {
        console.error('路由跳转失败:', err);
      });
    } else {
      MessagePlugin.error(res.message || '登录失败');
    }
  } catch (error) {
        console.error('登录失败:', error);
        MessagePlugin.error('登录失败，请稍后重试');
  } finally {
        loading.value = false;
  }
};

    
</script>

<style scoped>
    @import "./login.css";
</style>
